// extracted by mini-css-extract-plugin
export default {"alertTitle":"U2VsOzu3SfgEY4VV4jVC","alertContent":"AB18gPlb0PMClkedByaQ"};